"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var evaluatePoint_1 = require("./evaluatePoint");

exports.evaluatePointsVector = function (pointsVector, variableDictionary) {
  return {
    points: pointsVector.points.map(function (point) {
      return evaluatePoint_1.evaluatePoint(point, variableDictionary);
    })
  };
};